/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MindmapRequest } from '../models/MindmapRequest';
import type { StepDto } from '../models/StepDto';
import type { StepRequest } from '../models/StepRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StepApiService {
    /**
     * Get step details (video/quiz)
     * @param courseId
     * @param stepId
     * @returns StepDto Step details (video or quiz)
     * @throws ApiError
     */
    public static getStepDetails(
        courseId: string,
        stepId: string,
    ): CancelablePromise<StepDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courses/{courseId}/steps/{stepId}',
            path: {
                'courseId': courseId,
                'stepId': stepId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param courseId
     * @param stepId
     * @param requestBody
     * @returns StepDto Success response
     * @throws ApiError
     */
    public static updateStep(
        courseId: string,
        stepId: string,
        requestBody: StepRequest,
    ): CancelablePromise<StepDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/courses/{courseId}/steps/{stepId}',
            path: {
                'courseId': courseId,
                'stepId': stepId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param courseId
     * @param stepId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateMindmap(
        courseId: string,
        stepId: string,
        requestBody: MindmapRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/courses/{courseId}/steps/{stepId}/mindmap',
            path: {
                'courseId': courseId,
                'stepId': stepId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param courseId
     * @param requestBody
     * @returns StepDto Success response
     * @throws ApiError
     */
    public static createStep(
        courseId: string,
        requestBody: StepRequest,
    ): CancelablePromise<StepDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/courses/{courseId}/steps',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
